// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3kRoQ","requiredAsterisk":"Info_requiredAsterisk__1OL13"};